export const listPos = async params => {
  return await window.$vue.$get({ endpoint: "/pos", params })
}

export const listActivePos = async params => {
  return await window.$vue.$get({
    endpoint: "/pos/list-all",
    params
  })
}

export const listRolesAccessTime = async params => {
  return await window.$vue.$get({
    endpoint: "/role/list-all",
    params
  })
}

export const fetchPos = async uuid => {
  return await window.$vue.$get({ endpoint: `/pos/${uuid}` })
}

export const createPos = async data => {
  return await window.$vue.$post({ endpoint: "/pos", data })
}

export const editPos = async (data, uuid) => {
  return await window.$vue.$put({ endpoint: `/pos/${uuid}`, data })
}

export const changeStatusPos = async (data, uuid) => {
  return await window.$vue.$put({
    endpoint: `/pos/change-status/${uuid}`,
    data
  })
}

export const getAddressFromPostcode = async postcode => {
  return await window.$vue.$get({
    endpoint: `/city/raw-postcode/${postcode}`
  })
}

export const getAllPos = async () => {
  return await window.$vue.$get({
    endpoint: `/pos/list-all`
  })
}

export const listPossibleUserPos = async () => {
  return await window.$vue.$get({
    endpoint: `/user/list-possible-user-pos`
  })
}
